export default from './profile-page-layout';



// WEBPACK FOOTER //
// ./app/components/profile-page-layout/index.js